import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-issue',
  templateUrl: './card-issue.component.html',
  styleUrls: ['./card-issue.component.css']
})
export class CardIssueComponent implements OnInit {
  breadCrumb: any;
  constructor() { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Card Issuing',
      parent: 'Home',
      subLink: null
    };
  }

}
